import React, {lazy, Suspense} from 'react';
import GuestGuard from "gaurds/GuestGuard";
import {Outlet, Route} from "react-router-dom";
import Spinner from "../components/Spinner";

const Login = lazy(() => import("../pages/login/Login"));
const ResetAndFirstTimePassword = lazy(() => import("../pages/resetAndFirstTimePassword/ResetAndFirstTimePassword"));
const ForgotPassword = lazy(() => import("../pages/forgotPassword/ForgotPassword"));

const GuestWrapper = (
    <GuestGuard>
        <Suspense fallback={<Spinner/>}>
            <Outlet/>
        </Suspense>
    </GuestGuard>
);

const guestRoutes = (
    <Route element={GuestWrapper}>
        <Route path='/' element={<Login/>}/>
        <Route path='/reset-password' element={<ResetAndFirstTimePassword/>}/>
        <Route path='/forgot-password' element={<ForgotPassword/>}/>
    </Route>
);

export default guestRoutes;
